import { useEffect, useState } from "react";
import ProjectTable from "../blocks/projectTable";
import Breadcrums from "../components/breadcrums";
import { GetClients, GetProjectByClient, getProjectMaster, AddClient, AddProjectMaster } from "../api/project-api";
import ClientTable from "../blocks/clientTable";
import { useSnackbar } from "react-simple-snackbar";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import logger from "../utils/logger";

const breadcrumLinks = [{ name: "Clients", href: "/clients", current: true }];

export default function Client() {
    const [client, setClient] = useState<any[]>([]);
    const [openSnackbar] = useSnackbar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [clientName, setClientName] = useState("");
    const [clientAddress, setClientAddress] = useState("");
    const [clientVendor, setClientVendor] = useState("");
    const [paymentTerms, setPaymentTerms] = useState("30");
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (client.length === 0) {
            GetClients().then((data: any) => {
                setClient(data);
            });
        }
    }, [client]);

    const handleCreateClient = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!clientName.trim()) {
            openSnackbar("Client name is required.");
            return;
        }
        setIsSubmitting(true);
        try {
            await AddClient({
                name: clientName.trim(),
                address: clientAddress.trim(),
            })
                .then((res) => {
                    console.log("Client created:", res);

                    // Project master entry
                    AddProjectMaster({
                        // pid: `CLIENT-${result.id}`,
                        name: clientName.trim(),
                        cid: res[0]?.id || res?.id, // Adjust based on actual response structure
                        payment_terms: parseInt(paymentTerms) || 30,
                        vendor: clientVendor.trim(),
                    }).then((res) => {
                        console.log("Project master entry created:", res);
                    });

                    // Clear Form and Refresh Client List
                    openSnackbar("Client created successfully.");
                    setIsModalOpen(false);
                    setClientName("");
                    setClientAddress("");
                    setClientVendor("");
                    setPaymentTerms("30");
                    GetClients().then((data: any) => setClient(data));
                })
                .catch((err) => {
                    logger.error("Error in AddClient:", err);
                    throw err;
                });
        } catch (error) {
            openSnackbar("Failed to create client.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <main className="">
                {/* <PageHeader breadcrumLinks={breadcrumLinks} actions={actionLinks} title={"Projects"} summary={"Project Portfolio Snapshot"} summaryLine={"Overview of Ongoing and Completed Initiatives."} /> */}

                <div className="px-4 pt-5 mx-auto sm:px-6 lg:px-8">
                    <Breadcrums breadcrumLinks={breadcrumLinks} module={"Projects"} />
                </div>

                <div className="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
                    <div className="flex-1 min-w-0">
                        <h1 className="text-2xl font-semibold text-gray-900">Clients/Projects</h1>
                        <p className="mt-2 text-sm text-gray-700">
                            <b>Project Portfolio Snapshot</b> - Overview of Ongoing and Completed Initiatives.
                        </p>
                    </div>
                    <div className="flex mt-4 sm:mt-0 sm:ml-4">
                        <button type="button" onClick={() => setIsModalOpen(true)} className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-900 border border-transparent rounded-md shadow-sm order-0 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-1 sm:ml-3">
                            Create
                        </button>
                    </div>
                </div>

                <section className="px-4 py-5 sm:p-6">
                    {/* <ProjectList /> */}
                    {client && <ClientTable clients={client} />}
                </section>

                <Transition.Root appear show={isModalOpen} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={() => setIsModalOpen(false)}>
                        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-300" leaveFrom="opacity-100" leaveTo="opacity-0">
                            <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex items-center justify-center min-h-full p-4 text-center">
                                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-300" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                                    <Dialog.Panel className="relative overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-lg">
                                        <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                                            <Dialog.Title as="h3" className="mb-4 text-lg font-semibold leading-6 text-gray-900">
                                                Create New Client
                                            </Dialog.Title>
                                            <form onSubmit={handleCreateClient}>

                                                 <div className="mb-4">
                                                    <label htmlFor="clientName" className="block mb-2 text-sm font-medium text-gray-700">
                                                       Client 
                                                    </label>
                                                    <input type="text" id="clientName" value={clientName} onChange={(e) => setClientName(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Enter Client name" required />
                                                </div>
                                                <div className="mb-4">
                                                    <label htmlFor="clientVendor" className="block mb-2 text-sm font-medium text-gray-700">
                                                        Vendor Name
                                                    </label>
                                                    <input type="text" id="clientVendor" value={clientVendor} onChange={(e) => setClientVendor(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Enter Vendor name" />
                                                </div>
                                               
                                                <div className="mb-4">
                                                    <label htmlFor="clientAddress" className="block mb-2 text-sm font-medium text-gray-700">
                                                        Address
                                                    </label>
                                                    <textarea id="clientAddress" value={clientAddress} onChange={(e) => setClientAddress(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Enter client address" rows={3} />
                                                </div>

                                                <div className="mb-4">
                                                    <label htmlFor="paymentTerms" className="block mb-2 text-sm font-medium text-gray-700">
                                                        Payment Terms (Days)
                                                    </label>
                                                    <input type="number" id="paymentTerms" value={paymentTerms} onChange={(e) => setPaymentTerms(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" min="1" />
                                                </div>
                                                <div className="flex justify-end gap-3 mt-6">
                                                    <button type="button" onClick={() => setIsModalOpen(false)} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                                                        Cancel
                                                    </button>
                                                    <button type="submit" disabled={isSubmitting} className="px-4 py-2 text-sm font-medium text-white bg-blue-900 rounded-lg hover:bg-blue-800 disabled:opacity-50">
                                                        {isSubmitting ? "Creating..." : "Create Client"}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </main>
        </>
    );
}
